import {IFluorophore} from "../../models/fluorophore";
import {DynamicAutoSuggest} from "./DynamicAutoSuggest";

export class FluorophoreAutoSuggest extends DynamicAutoSuggest<IFluorophore> {
}
